module.exports = __webpack_public_path__ + "ef4178cc7efc1425e9e41969c6b2c834.jpg";